<script setup>
import { useTranslationsStore } from '@/store/translations';
import { storeToRefs } from 'pinia';

const translationStore = useTranslationsStore();
const { trans } = storeToRefs(translationStore);

const props = defineProps({
    id: {
        type: String,
        default: 'unknown_id',
    },
    context: {
        type: Object,
        default: () => {
            return {};
        },
    },
});
</script>

<template>
    <!-- eslint-disable vue/no-v-html -->
    <span class="translation" v-html="trans(props.id, true, context)"></span>
    <!--eslint-enable-->
</template>

<style></style>
